import { useCategoryPageFilterKeys } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/CategoryPageShareables/hooks/useCategoryPageFilterKeys";
import { useIsBestsellers } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/useIsBestsellers";

export const useLayoutElementFilterKeys = () => {
  const filterKeys = useCategoryPageFilterKeys();
  const { isBestsellers } = useIsBestsellers();

  // Do not want to refetch layout elements on filter keys on bestsellers pages
  // This is an optimization as the layout elements can be a bit heavy and didn't
  // want to slow things down
  // However, this pattern should not be followed as diverging categories based upon
  // a URL ID or category path identifier is fragile (in case the backend defined value changes)
  if (isBestsellers) {
    return [];
  }
  return filterKeys;
};
